import React from "react";
import * as Yup from "yup";

import "./index.scss";
import Context from "../../../../../../context";
import { IItem } from "../../../../../../types/common.interface";
import { useFormik } from "formik";
import {
  CustomButton2,
  CustomInput,
  CustomModal,
  CustomRadioButtonGroup,
  CustomTimePiker,
  CustomView,
} from "../../../../../../components";
import { OFFLINE_PAYER_WAY } from "../../../../../../values/dropdownItems";
import utils from "../../../../../../utils";
import { useTranslation } from "react-i18next";

const PayDebt = ({}) => {
  const { showModal, setShowModal, isLoading, selectedDebt, onPayDebt } =
    React.useContext(Context.DebtScreen);
  const [selectedPayerWay, setSelectedPayerWay] = React.useState<IItem>();
  const [date, setDate] = React.useState<string>(new Date().toDateString());
  const [errors, setErrors] = React.useState({ payerType: "", payerWay: "" });

  const { t } = useTranslation();
  const onSubmit = () => {
    let selectedErrors = { payerType: "", payerWay: "" };

    if (!selectedPayerWay) {
      selectedErrors = {
        ...selectedErrors,
        payerWay: t("pay_way_is_required"),
      };
    }
    setErrors(selectedErrors);
    formik.submitForm();
  };

  const formik = useFormik({
    initialValues: {
      fishNumber: "",
    },
    validationSchema: Yup.object({
      fishNumber: Yup.string().required(t("enter_fish_number")),
    }),
    onSubmit: (values) => {
      if (selectedPayerWay) {
        onPayDebt!({
          debtId: selectedDebt._id,
          fishId: values.fishNumber,
          paymentType: selectedPayerWay?.value as string,
          paidDate: utils.convertGregorianToJalali({
            date: date as string,
            format: "jYYYY/jMM/jDD",
          }),
        });
      }
    },
  });

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------

  return (
    <section id="school-approve-modal-container">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={showModal === "PAY_DEBT"}
      >
        <form>
          <CustomView.Container className="approve-form-content">
            <>
              <CustomView.Row className="radio-button-group">
                <CustomView.Column medium={4} className="form-colum">
                  <CustomInput
                    name="price"
                    id="price"
                    label={t("price")}
                    value={
                      utils.convertNumberToPrice(selectedDebt?.totalAmount) +
                      " تومان"
                    }
                    isDisable
                  />
                </CustomView.Column>
                <CustomView.Column medium={4} className="form-colum">
                  <div className="input-label right">
                    <label>{t("payDate")}</label>
                  </div>
                  <CustomTimePiker
                    placeholder={t("payDate")}
                    defaultValue={date}
                    onChange={(event) => setDate(event)}
                  />
                </CustomView.Column>
                <CustomView.Column medium={12} className="form-colum dropdown">
                  <div className="form-colum">{t("payWay")}</div>
                  <CustomRadioButtonGroup
                    menus={OFFLINE_PAYER_WAY}
                    selected={selectedPayerWay as IItem}
                    onClick={(event: IItem | null) => {
                      setSelectedPayerWay(event as IItem);
                      setErrors({ ...errors, payerWay: "" });
                    }}
                    canNull={false}
                  />
                  <div className="error">
                    {errors.payerWay !== "" && errors.payerWay}
                  </div>
                </CustomView.Column>
                <CustomView.Column medium={4} className="form-colum">
                  <CustomInput
                    name="fishNumber"
                    id="fishNumber"
                    label={t("fishNumber")}
                    value={formik.values.fishNumber}
                    onValueChange={formik.handleChange}
                    formikProps={{ onBlur: formik.handleBlur }}
                    error={
                      formik.errors.fishNumber && formik.touched.fishNumber
                    }
                    errorText={formik.errors.fishNumber}
                  />
                </CustomView.Column>
              </CustomView.Row>
              <br />
            </>
            <CustomView.Row className="form-row">
              <CustomView.Column
                large={3}
                medium={4}
                small={6}
                className="form-colum"
              >
                <CustomButton2
                  isLoading={isLoading}
                  onClick={() => setShowModal!("NONE")}
                  title={t("cancel")}
                  type="danger"
                />
              </CustomView.Column>
              <CustomView.Column
                large={3}
                medium={4}
                small={6}
                className="form-colum"
              >
                {/* {role === "ADMIN" && <SwitchButtonHandler />} */}
                <CustomButton2
                  isLoading={isLoading}
                  onClick={onSubmit}
                  title={t("approve")}
                  type={"primary"}
                />
              </CustomView.Column>
            </CustomView.Row>
          </CustomView.Container>
        </form>
      </CustomModal>
    </section>
  );
};
export default PayDebt;
